import { ActionButton, Flex, Text, View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import Apps from "@spectrum-icons/workflow/Apps"
import Settings from "@spectrum-icons/workflow/Settings"
import Search from "@spectrum-icons/workflow/Search"
import Calendar from "@spectrum-icons/workflow/Calendar"
import Segments from "@spectrum-icons/workflow/Segments"

export function MobileNavigationBar() {
  return (
    <View
      height="size-800"
      backgroundColor="gray-200"
      width="100%"
      UNSAFE_className="sm:hidden"
      paddingBottom="size-65"
    >
      <Flex
        alignItems="center"
        justifyContent="space-evenly"
        width="100%"
        height="100%"
      >
        <ActionButton isQuiet>
          <Flex direction="column" alignItems="center" alignContent="center">
            <Apps />
            <Text>Home</Text>
          </Flex>

        </ActionButton>
        <ActionButton isQuiet>
          <Calendar />
          <Text>Rota</Text>
        </ActionButton>
        <ActionButton isQuiet>
          <Segments />
          <Text>Referrals</Text>
        </ActionButton>
        <ActionButton isQuiet>
          <Search />
          <Text>Search</Text>
        </ActionButton>
        <ActionButton isQuiet>
          <Settings />
          <Text>Settings</Text>
        </ActionButton>
      </Flex>
    </View>
  )
}
